import { ajax as request } from '@blade/common';
/** ==============================@Description: 任务管理============================== */
/**
*@Description: 添加任务
*@Date: 2020-09-01 14:39:57
*/
export const postTask = (data) => request({
    url: '/api/task-management/api/v1/sc/task',
    method: 'POST',
    data
});
/**
*@Description: 布控任务详情
*@Date: 2020-09-01 14:39:57
*/
export const getTaskDetail = (id) => request({
    url: '/api/task-management/api/v1/sc/task/' + id,
    method: 'GET'
});
/**
*@Description: 修改任务
*@Date: 2020-09-01 14:39:57
*/
export const putTargetsDetail = (data) => request({
    url: '/api/task-management/api/v1/sc/task',
    method: 'PUT',
    data
});
/**
*@Description: 删除任务
*@Date: 2020-09-01 14:39:57
*/
export const deleteTargetsDetail = (targetId) => request({
    url: '/api/task-management/api/v1/sc/task/' + targetId,
    method: 'DELETE'
});
/**
*@Description: 停用任务
*@Date: 2020-09-01 14:39:57
*/
export const disableTask = (id) => request({
    url: '/api/task-management/api/v1/sc/task/' + id + '/disable',
    method: 'GET'
});
/**
*@Description: 启用任务
*@Date: 2020-09-01 14:39:57
*/
export const enableTask = (id) => request({
    url: '/api/task-management/api/v1/sc/task/' + id + '/enable',
    method: 'GET'
});
/**
*@Description: 任务列表
*@Date: 2020-09-01 14:39:57
*/
export const getTaskList = (data) => request({
    url: '/api/task-management/api/v1/sc/task/list',
    method: 'POST',
    data
});
export const getLablePerson = (deviceId) => request({
    url: `/api/task-management/api/v1/sc/task/device/lablePerson/${deviceId}`,
    method: 'GET',
});
export const getModel = (deviceId) => request({
    url: `/api/task-management/api/device/config/model/${deviceId}`,
    method: 'GET',
});
export const getCrossLineTasks = (deviceId) => request({
    url: `/api/task-management/api/v1/sc/task/crossLine/device/${deviceId}`,
    method: 'GET',
});
export const getRoi = (deviceId, taskType) => request({
    url: `/api/task-management/api/v1/sc/task/device/${deviceId}/type/${taskType}`,
    method: 'GET',
});
